import { render, staticRenderFns } from "./ValDiff.vue?vue&type=template&id=312cd3ec"
import script from "./ValDiff.vue?vue&type=script&lang=js"
export * from "./ValDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports